/*
 formCheckPassword
 rules:
 6 characters required
 1 lowercase a-z required
 1 capital a-z required
 1 number required
 1 special character required
 */

const formPasswordCheck = (password) => {

  let checkPassword = {
    isValid: false,
    error: ''
  };

  // check minimum characters
  if (password.length < 6) {
    checkPassword.error = 'At least 6 characters required';
  }

  // check special characters
  else if (password.search(/[\W_]+/) === +-1) {
    checkPassword.isValid = false;
    checkPassword.error = 'At least one special character required';
  }

  // check numbers
  else if (password.search(/[0-9]+/) === +-1) {
    checkPassword.isValid = false;
    checkPassword.error = 'At least one number required';
  }

  // check lowercase letter
  else if ((password.search(/[a-z]+/) === -1)) {
    checkPassword.isValid = false;
    checkPassword.error = 'At least one lowercase letter required';
  }

  // check capital letter
  else if ((password.search(/[A-Z]+/) === -1)) {
    checkPassword.isValid = false;
    checkPassword.error = 'At least one capital letter required';
  }

  // password is valid
  else {
    checkPassword.isValid = true;
  }

  return checkPassword;
};

export default formPasswordCheck;



// WEBPACK FOOTER //
// ./src/utils/forms/form-password-check.js